module.exports = "<div class=\"row\" id=\"row-content-about\">\r\n    <div class=\"col-12 p-0\">\r\n        <div class=\" pt-5 home-page\" id=\"collections-container-about\">\r\n        \r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.html
// module id = ./src/app/about/about.component.html
// module chunks = main